import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex items-end justify-center top-0 bottom-0 w-full h-full"
};
const _hoisted_2 = {
  key: 1,
  class: "flex-center rounded border p-2 mb-4"
};
const _hoisted_3 = {
  class: "text-2xl font-bold"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "grow"
}, null, -1);
import { Season } from "@/modules/season/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { app } from "@/di";
import { DayEvaluator } from "@/modules/season/services/DayEvaluator";
import { EventEmitter } from "@/modules/base/events";
import { AfterSeasonEvaluationEvent } from "@/modules/season/events/AfterSeasonEvaluationEvent";
import { AfterDayEvaluationEvent } from "@/modules/season/events/AfterDayEvaluationEvent";
import { Match } from "@/modules/match/entity";
import { nonblocking } from "@/utils";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import { Team } from "@/modules/team/entity";
import MatchPanel from "@/modules/diplomacy/components/MatchPanel.vue";
import { Brackets } from "typeorm";
import BeforeMatchMode from "@/modules/match/services/BeforeMatchMode";
import { WeekdayEnum } from "@/modules/base/enums";
import SettingRepository from "@/modules/settings/services/SettingRepository";
import CalendarTimeline from "@/modules/season/components/CalendarTimeline.vue";
import LastNotification from "@/modules/notifications/components/LastNotification.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Evaluation',
  async setup(__props) {
    let __temp, __restore;
    const team = ref();
    const season = ref();
    const matches = ref();
    const prevMatch = ref();
    const nextMatch = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.current();
      season.value = await Season.current();
      prevMatch.value = await Match.findPrev(season.value, team.value);
      nextMatch.value = await Match.findNext(season.value, team.value);
      matches.value = await Match.createQueryBuilder('match').leftJoin('match.homeTeam', 'homeTeam').leftJoin('match.awayTeam', 'awayTeam').innerJoinAndSelect('match.matchday', 'matchday').innerJoin('matchday.season', 'season').where('season.current = true').andWhere(new Brackets(query => {
        query.where('homeTeam.user = true').orWhere('awayTeam.user = true');
      })).andWhere('matchday.scheduledAt >= :dateFrom AND matchday.scheduledAt <= :dateTo', {
        dateFrom: season.value.startDate.startOf('month').format(),
        dateTo: season.value.startDate.endOf('month').format()
      }).getMany();
    })), __temp = await __temp, __restore(), __temp);
    const showEndSeason = computed(() => season.value.isLastDay);
    onUnmounted(app.get(EventEmitter).onOff([AfterSeasonEvaluationEvent, AfterDayEvaluationEvent], refresh));
    const dayEvaluator = app.get(DayEvaluator);
    const isCalculating = dayEvaluator.isCalculating;
    const isEvaluating = dayEvaluator.isEvaluating;
    const route = useRoute();
    const router = useRouter();
    const beforeMatchMode = app.get(BeforeMatchMode);
    const stopEvaluation = async () => {
      isEvaluating.value = false;
      // router.push({name: 'index'});
    };

    const startEvaluation = async () => {
      isEvaluating.value = true;
      await evaluateDay();
    };
    const endSeason = async () => {
      await evaluateDay();
      await router.push({
        name: 'index'
      });
    };
    const stopOnStartOfTheWeek = ref(([__temp, __restore] = _withAsyncContext(() => app.get(SettingRepository).get('stop_evaluation_on_start_of_the_week')), __temp = await __temp, __restore(), __temp));
    const evaluateDay = async () => {
      if (!beforeMatchMode.isEnabled() && (await beforeMatchMode.isBeforeMatchMode())) {
        beforeMatchMode.enable();
        isEvaluating.value = false;
        router.push({
          name: 'squads.formation.before-match'
        });
        return;
      }
      await nonblocking(() => dayEvaluator.evaluate());
      if (beforeMatchMode.isEnabled()) {
        isEvaluating.value = false;
        beforeMatchMode.disable();
        router.replace({
          name: 'index'
        });
      }
      if (showEndSeason.value || stopOnStartOfTheWeek.value && season.value.currentDate.weekday() === WeekdayEnum.MONDAY) {
        isEvaluating.value = false;
        return;
      }
      if (isEvaluating.value) {
        setTimeout(evaluateDay, app.get(ConfigRepository).get('season.waitBetweenDays'));
      }
    };
    onMounted(async () => {
      if (route.query.start) {
        await router.replace({
          name: 'evaluation'
        });
        if (!season.value.isLastDay) {
          setTimeout(() => startEvaluation(), 500);
        }
      }
    });
    app.get(EventEmitter).on(AfterSeasonEvaluationEvent, stopEvaluation);
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-tabbar": "",
        "hide-footer": "",
        "content-classes": {
          'flex flex-col justify-end': true
        }
      }, {
        footerButtons: _withCtx(() => [_unref(showEndSeason) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_NButton, {
          secondary: "",
          size: "large",
          class: "mr-4",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push({
            name: 'index'
          })),
          textContent: _toDisplayString(_ctx.$t('back'))
        }, null, 8, ["textContent"]), _createVNode(_component_NButton, {
          secondary: "",
          type: "error",
          size: "large",
          disabled: _unref(showEndSeason) && _unref(isCalculating),
          onClick: endSeason,
          textContent: _toDisplayString(_ctx.$t('end_season'))
        }, null, 8, ["disabled", "textContent"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_unref(isEvaluating) ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          size: "large",
          secondary: "",
          type: "error",
          plain: "",
          block: "",
          onClick: stopEvaluation,
          textContent: _toDisplayString(_ctx.$t('stop'))
        }, null, 8, ["textContent"])) : (_openBlock(), _createBlock(_component_NButton, {
          key: 1,
          type: "success",
          size: "large",
          secondary: "",
          plain: "",
          block: "",
          onClick: startEvaluation,
          textContent: _toDisplayString(_ctx.$t('start'))
        }, null, 8, ["textContent"]))], 64))]),
        default: _withCtx(() => [_createVNode(LastNotification, {
          class: "w-full my-2"
        }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: _normalizeClass(["py-2 w-full flex flex-col", {
            'h-full': _unref(showEndSeason)
          }])
        }, [!_unref(showEndSeason) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(CalendarTimeline, {
          season: season.value,
          class: "mb-4"
        }, null, 8, ["season"]), nextMatch.value ? (_openBlock(), _createBlock(MatchPanel, {
          key: 0,
          match: nextMatch.value,
          class: "mb-4 bg-green-50 w-full"
        }, null, 8, ["match"])) : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('end_of_season')), 1)), prevMatch.value ? (_openBlock(), _createBlock(MatchPanel, {
          key: 2,
          match: prevMatch.value,
          class: "mb-8 bg-sky-50"
        }, null, 8, ["match"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('end_of_season')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('end_of_season_info')), 1), _hoisted_4], 64))], 2)])]),
        _: 1
      });
    };
  }
});